module.exports = __webpack_public_path__ + "static/media/2021-image.4ace2b87.png";